import { create } from 'zustand';

/**
 * Cached lifecycle resolution by `entityType:entityId` (read-only; no toast).
 */
export const useLifecycleStore = create((set) => ({
    entries: {},

    setEntry: (key, value) =>
        set((state) => ({
            entries: { ...state.entries, [key]: value },
        })),

    mergeEntries: (partial) =>
        set((state) => ({
            entries: { ...state.entries, ...partial },
        })),

    clear: () => set({ entries: {} }),
}));
